<template>
 <div>
  关键字查询 
 </div>
</template>

<script>
 export default {
   name: 'valueCheck',
   data () {
     return {

     }
   },
   components: {

   }
 }
</script>

<style>

 
</style>



// WEBPACK FOOTER //
// src/components/home/components/components/check/valueCheck.vue